import React from 'react'

// Material-UI
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import { makeStyles, Typography } from '@material-ui/core';
// Components
import Navbar from "../components/NavbarTitle";
import Background from "../components/BackgroundPattern";
import Footer from '../components/Footer';

const useStyle = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  content: {
    marginTop: 20,
  },
  info: {
    margin: theme.spacing(2),
    "& .MuiAlert-icon": {
      fontSize: 40,
      padding: theme.spacing(1),
      margin: theme.spacing(1)
    }
  }
}))

const InfoTunggu = ({classes}) => {
  return (
    <section id="info-tunggu">
      <Grid container className={classes.content}>
        <Grid item xs={12}>
          <Alert variant="filled" severity="warning" className={classes.info} elevation={3}>
            <AlertTitle style={{paddingTop: 5}}>
              {"BERKAS SEDANG DI VALIDASI"}
            </AlertTitle>
            <Typography variant="body2">
              {"Mohon tunggu, berkas sedang di validasi oleh Panitia PCAB KSR PMI Unit UNJ."}
            </Typography>
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Alert variant="filled" severity="info" className={classes.info} elevation={3}>
            <AlertTitle style={{paddingTop: 5}}>
              {"NARAHUBUNG"}
            </AlertTitle>
            <Typography variant="body2">
              {"Untuk Informasi lebih lanjut, dapat menghubungi Panitia PCAB KSR PMI Unit UNJ melalui WhatsApp dengan nomor +62857-8031-7112."}
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </section>
  )
}

const ValidasiBerkasTunggu = () => {
  const classes = useStyle();
  return (
    <section id="validasi-berkas" className={classes.container}>
      <Background/>
      <Navbar title="VALIDASI BERKAS PENDAFTARAN" />
        <Container style={{flex: "1"}}>
          <InfoTunggu classes={classes}/>
        </Container>
      <Footer/>
    </section>
  )
}

export default ValidasiBerkasTunggu
